"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.DspPartnerToJSON = exports.DspPartnerFromJSONTyped = exports.DspPartnerFromJSON = exports.DspPartner = void 0;
/**
 *
 * @export
 */
exports.DspPartner = {
    ActiveAgentAg: 'ACTIVE_AGENT_AG',
    Adform: 'ADFORM',
    AdobeAdvertisingCloud: 'ADOBE_ADVERTISING_CLOUD',
    Adtheorent: 'ADTHEORENT',
    AllmediadeskGmbh: 'ALLMEDIADESK_GMBH',
    Amazon: 'AMAZON',
    Amobee: 'AMOBEE',
    AppierInc: 'APPIER_INC',
    BasisTechnologies: 'BASIS_TECHNOLOGIES',
    BeeswaxIo: 'BEESWAX_IO',
    Bidswitch: 'BIDSWITCH',
    BidtheatreAb: 'BIDTHEATRE_AB',
    BlisMediaLimited: 'BLIS_MEDIA_LIMITED',
    Carta: 'CARTA',
    ConversantMedia: 'CONVERSANT_MEDIA',
    Criteo: 'CRITEO',
    DeepIntent: 'DEEP_INTENT',
    Dv360: 'DV360',
    Hawk: 'HAWK',
    IlluminInc: 'ILLUMIN_INC',
    Madhive: 'MADHIVE',
    MediasmartMobileSl: 'MEDIASMART_MOBILE_SL',
    Octillion: 'OCTILLION',
    Paytunes: 'PAYTUNES',
    Quantcast: 'QUANTCAST',
    RokuOneview: 'ROKU_ONEVIEW',
    RtbhouseAnonymousUsers: 'RTBHOUSE_ANONYMOUS_USERS',
    SimpliFi: 'SIMPLI_FI',
    SoNetMediaNetworks: 'SO_NET_MEDIA_NETWORKS',
    Splicky: 'SPLICKY',
    Stackadapt: 'STACKADAPT',
    SupershipInc: 'SUPERSHIP_INC',
    TaptapNetworksSl: 'TAPTAP_NETWORKS_SL',
    TradeDeskExpressLane: 'TRADE_DESK_EXPRESS_LANE',
    TradeDesk: 'TRADE_DESK',
    TravelAudienceGmbh: 'TRAVEL_AUDIENCE_GMBH',
    ViantInc: 'VIANT_INC',
    Xandr: 'XANDR',
    YahooDsp: 'YAHOO_DSP'
};
function DspPartnerFromJSON(json) {
    return DspPartnerFromJSONTyped(json, false);
}
exports.DspPartnerFromJSON = DspPartnerFromJSON;
function DspPartnerFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
exports.DspPartnerFromJSONTyped = DspPartnerFromJSONTyped;
function DspPartnerToJSON(value) {
    return value;
}
exports.DspPartnerToJSON = DspPartnerToJSON;
